import { BasketContents } from '../BasketContents';
import { DiscountCode } from '../DiscountCode';
import { Card, DiscountStack } from './CheckoutSummaryPanel.styles';
import type { CheckoutSummaryPanelProps } from './CheckoutSummaryPanel.types';

export function CheckoutSummaryPanel({
  items,
  totalPrice,
  view,
  onViewChange,
  guests,
  onRemoveItem,
  subtotal,
  promotionsDiscount,
  vouchersDiscount,
  promoCode,
  voucherCode,
  locale,
  labels,
}: CheckoutSummaryPanelProps) {
  const discountSlot =
    promoCode || voucherCode ? (
      <DiscountStack>
        {promoCode && <DiscountCode {...promoCode} />}
        {voucherCode && <DiscountCode {...voucherCode} />}
      </DiscountStack>
    ) : undefined;

  return (
    <Card data-testid="checkout-summary-panel">
      <BasketContents
        items={items}
        totalPrice={totalPrice}
        view={view}
        onViewChange={onViewChange}
        guests={guests}
        onRemoveItem={onRemoveItem}
        showTitle={false}
        subtotal={subtotal}
        promotionsDiscount={promotionsDiscount}
        vouchersDiscount={vouchersDiscount}
        discountSlot={discountSlot}
        locale={locale}
        labels={labels}
      />
    </Card>
  );
}
